import { ArrowUpRight, Mail, MapPin, Clock } from "lucide-react";
import { useLang } from "@/i18n";
import { scrollToId, PICHONTEAM_URL, LA_PATRONA_URL } from "@/lib/site";

const LINKS = ["historia", "carta", "vision", "servicios", "galeria", "contacto"];
const ADDRESS = "Travesía Estrecha de San Andrés, 3, 15002 A Coruña, España";
const MAP_Q = encodeURIComponent("El gato con copas, " + ADDRESS);

export const Footer = () => {
  const { t } = useLang();
  const label = (id) => (id === "contacto" ? t.nav.cta : t.nav[id]);
  return (
    <footer data-testid="site-footer" className="bg-tropical-dark text-paper pt-20 pb-10 overflow-hidden">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-12">
          <div className="md:col-span-5">
            <img src="/sello-gato.jpg" alt="El gato con copas" className="w-48 sm:w-56 rounded-2xl border-4 border-paper/10" data-testid="footer-logo" />
            <p className="mt-5 text-paper/75 max-w-sm">{t.footer.tagline}</p>
            <ul className="mt-6 space-y-2 text-sm text-paper/80">
              <li className="flex items-start gap-2"><MapPin size={15} className="text-banana mt-0.5 shrink-0" /><a href={`https://www.google.com/maps/search/?api=1&query=${MAP_Q}`} target="_blank" rel="noopener noreferrer" className="hover:text-banana" data-testid="footer-address">{ADDRESS}</a></li>
              <li className="flex items-center gap-2"><Clock size={15} className="text-banana" />{t.footer.hours}</li>
              <li className="flex items-center gap-2"><Mail size={15} className="text-banana" /><a href="mailto:elgatoconcopascoruna@gmail.com" className="hover:text-banana" data-testid="footer-email">elgatoconcopascoruna@gmail.com</a></li>
            </ul>
          </div>
          <div className="md:col-span-3">
            <p className="font-mono-ed text-xs uppercase tracking-[0.25em] text-banana">{t.footer.explore}</p>
            <ul className="mt-5 space-y-2.5">
              {LINKS.map((id) => (
                <li key={id}><button data-testid={`footer-link-${id}`} onClick={() => scrollToId(id)} className="text-paper/85 hover:text-banana transition-colors">{label(id)}</button></li>
              ))}
            </ul>
          </div>
          <div className="md:col-span-4">
            <p className="font-mono-ed text-xs uppercase tracking-[0.25em] text-banana">{t.footer.partners}</p>
            <div className="mt-5 flex flex-col gap-3">
              <a href={PICHONTEAM_URL} target="_blank" rel="noopener" data-testid="footer-link-pichonteam"
                className="group flex items-center justify-between rounded-2xl border border-paper/20 px-5 py-4 hover:border-banana transition-colors">
                <img src="/pichonteam-logo.jpg" alt="#PICHONTEAM Growth Partners" className="h-12 w-12 rounded-lg mr-4 shrink-0" />
                <span className="flex-1"><span className="block font-display text-xl">#PICHONTEAM</span><span className="text-xs text-paper/70">{t.footer.design} · www.pichonteam.es</span></span>
                <ArrowUpRight className="transition-transform group-hover:rotate-45" />
              </a>
              <a href={LA_PATRONA_URL} target="_blank" rel="noopener" data-testid="footer-link-lapatrona"
                className="group flex items-center justify-between rounded-2xl border border-paper/20 px-5 py-4 hover:border-banana transition-colors">
                <span className="flex-1"><span className="block font-display text-xl">La Patrona</span><span className="text-xs text-paper/70">{t.footer.patrona} · www.lapatronaeventos.es</span></span>
                <ArrowUpRight className="transition-transform group-hover:rotate-45" />
              </a>
            </div>
          </div>
        </div>
        <div className="mt-14 overflow-hidden rounded-[2rem] border-4 border-paper/15 h-[280px] sm:h-[360px]" data-testid="footer-map">
          <iframe
            title="Mapa El gato con copas"
            src={`https://www.google.com/maps?q=${MAP_Q}&z=17&output=embed`}
            className="h-full w-full border-0"
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
            allowFullScreen
          />
        </div>
        <p className="font-brand text-[18vw] leading-none text-paper/10 mt-16 whitespace-nowrap select-none" aria-hidden="true">El gato</p>
        <div className="mt-6 pt-6 border-t border-paper/15 flex flex-col sm:flex-row justify-between gap-3 text-xs text-paper/65">
          <span>© {new Date().getFullYear()} El gato con copas. {t.footer.rights}</span>
          <a href="/admin" data-testid="footer-admin-link" className="hover:text-banana">Admin</a>
        </div>
      </div>
    </footer>
  );
};
